import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useHCaptchaStore } from "@faire/retailer-visitor-shared/stores/domain/HCaptchaStore";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { useCallback, useEffect, useRef } from "react";
/**
 * Mimics the behavior of fetching the widgetID from hCaptcha asynchronously.
 *
 * Behind the scenes, it uses the useHCaptchaStore hook to get the widgetID/error
 * and wraps the response with a promise.
 */ export var useFetchWidgetID = function(enabled) {
    var resolveRef = useRef(null);
    var rejectRef = useRef(null);
    var promiseRef = useRefFrom(function() {
        return new Promise(function(resolve, reject) {
            resolveRef.current = resolve;
            rejectRef.current = reject;
        });
    });
    var _useHCaptchaStore = _sliced_to_array(useHCaptchaStore([
        "widgetID",
        "initializationError"
    ]), 2), _useHCaptchaStore_ = _useHCaptchaStore[0], widgetID = _useHCaptchaStore_.widgetID, initializationError = _useHCaptchaStore_.initializationError, setHCaptchaStore = _useHCaptchaStore[1];
    var fetchWidgetID = useCallback(function() {
        if (!enabled) {
            return Promise.reject(ILoginRequest.IHCaptchaData.HCaptchaError.SETTING_OFF);
        }
        return promiseRef.current;
    }, [
        enabled,
        promiseRef
    ]);
    useEffect(function() {
        if (enabled) {
            setHCaptchaStore({
                isHCaptchaEnabled: true
            });
        }
    }, [
        enabled,
        setHCaptchaStore
    ]);
    useEffect(function() {
        if (widgetID) {
            var _resolveRef_current;
            (_resolveRef_current = resolveRef.current) === null || _resolveRef_current === void 0 ? void 0 : _resolveRef_current.call(resolveRef, widgetID);
        } else if (initializationError) {
            var _rejectRef_current;
            (_rejectRef_current = rejectRef.current) === null || _rejectRef_current === void 0 ? void 0 : _rejectRef_current.call(rejectRef, initializationError);
        }
    }, [
        initializationError,
        widgetID
    ]);
    return {
        widgetID: widgetID,
        widgetError: initializationError,
        fetchWidgetID: fetchWidgetID
    };
};
